// SPDX-FileCopyrightText: 2026 Stadtplatz.de
//
// SPDX-License-Identifier: EUPL-1.2

import React from "react";
import { STAT_ENTRIES } from "./constants";

const AvailabilityStats = ({ stats }) => {
  const { counts, total, seas } = stats;

  const values = {
    total,
    event: counts.event,
    delivery: counts.delivery,
    construction: counts.construction,
    infra: counts.infra,
    seas,
  };

  return (
    <section className="av-stats" aria-label="Übersicht belegter Tage">
      {STAT_ENTRIES.map((entry, index) => {
        const val = values[entry.key];
        const sub =
          entry.key === "seas"
            ? entry.sub.replace("{total}", String(total))
            : entry.sub;

        return (
          <div
            key={entry.key}
            className="av-stat-card"
            data-stat-key={entry.key}
            style={{
              borderTopColor: `var(${entry.colorVar})`,
              animationDelay: `${index * 40}ms`,
            }}
          >
            <div className="av-stat-label">{entry.label}</div>
            <div
              className="av-stat-value"
              style={{ color: `var(${entry.colorVar})` }}
            >
              {val}
            </div>
            <div className="av-stat-sub">{sub}</div>
          </div>
        );
      })}
    </section>
  );
};

export default AvailabilityStats;
